module.exports = __webpack_public_path__ + "c80e39b7e232471855dfe5fadc150415.pdf";